export const HOME = 'HOME';
export const LOGIN = 'LOGIN';
export const SIGNUP = 'SIGNUP';
export const USERS = 'USERS';
export const RED_MAT_CALCULATIONS = 'RED_MAT_CALCULATIONS';
export const RED_MAT_CALCULATION_EDIT = 'RED_MAT_CALCULATION_EDIT';
export const RED_MAT_CALCULATION_RESULTS = 'RED_MAT_CALCULATION_RESULTS';
